module.exports = "mutation UpdateIssueAssignable($data:IssueAssignableInput!){updateIssueAssignable(data:$data){success}}"